import axios, { getData } from "../../../lib/axios"

export const signUrl = async (data) => {
    return axios.post("/presign_url", data).then(getData)
}